import { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import AssetInformation from "./pages/AssetInformation";
import Contact from "./pages/Contact";
import RequestDemo from "./pages/RequestDemo";
import DigitalBuildingInformation from "./pages/DigitalBuildingInformation";
import DigitalOM from "./pages/DigitalOM";
import DocumentsDrawings from "./pages/DocumentsDrawings";
// @todo: add resources back later
// import Resources from "./pages/Resources";
import Search from "./pages/Search";
import WhoItsFor from "./pages/WhoItsFor";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import CookiePolicy from "./pages/CookiePolicy";
import TermsAndConditions from "./pages/TermsAndConditions";
import AI from "./pages/AI";
import NotFound from "./pages/NotFound";
import ScrollToTop from "./components/ScrollToTop";
import "./styles/global.scss";
import tracker from "./utils/openReplay";
import { initGA } from "./utils/googleAnalytics/google-analytics";
import AnalyticsTracker from "./components/AnalyticsTracker";

const App = () => {
  useEffect(() => {
    if (process.env.NODE_ENV === "production") {
      tracker.start();
      initGA(); // only once in production
    }
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <AnalyticsTracker />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/ai" element={<AI />} />
        <Route path="/asset-information" element={<AssetInformation />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/request-a-demo" element={<RequestDemo />} />
        <Route
          path="/digital-building-information"
          element={<DigitalBuildingInformation />}
        />
        <Route path="/digital-om" element={<DigitalOM />} />
        <Route path="/documents-drawings" element={<DocumentsDrawings />} />
        {/* @todo: add resources back later */}
        {/* <Route path="/resources" element={<Resources />} /> */}
        <Route path="/search" element={<Search />} />
        <Route path="/who-its-for" element={<WhoItsFor />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/cookie-policy" element={<CookiePolicy />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
};

export default App;
